import { render, staticRenderFns } from "./MyEcosystems.vue?vue&type=template&id=14f82a6a&scoped=true&"
import script from "./MyEcosystems.vue?vue&type=script&lang=js&"
export * from "./MyEcosystems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f82a6a",
  null
  
)

export default component.exports